<profile-card class="grow" title="Votre abonnement">
  <user-subscription-card></user-subscription-card>
</profile-card>
